// ── ASSICURAZIONE OCCHIALI ──
const INSURANCE_VARIANT_ID = 55705423380820;

// Gestisci tutto in fase capture PRIMA che cart.js intervenga
document.addEventListener('change', async (e) => {
  if (!e.target.classList.contains('cart-insurance-checkbox')) return;

  e.stopPropagation();
  e.stopImmediatePropagation();
  e.preventDefault();

  const checkbox = e.target;
  const productName = checkbox.dataset.productName || '';

  document.querySelectorAll('.cart-insurance-checkbox').forEach(cb => cb.disabled = true);

  try {
    if (checkbox.checked) {
      await addInsurance(INSURANCE_VARIANT_ID, productName);
    } else {
      await removeInsurance(INSURANCE_VARIANT_ID, productName);
    }
    await refreshCartDrawer();
  } catch (err) {
    console.error('Errore assicurazione:', err);
    checkbox.checked = !checkbox.checked; // rollback
    document.querySelectorAll('.cart-insurance-checkbox').forEach(cb => cb.disabled = false);
  }
}, true);

document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('#CartDrawer-CartItems');
  if (drawer) {
    const observer = new MutationObserver(() => {
      setTimeout(syncInsuranceCheckboxes, 100);
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }
});

function syncInsuranceCheckboxes() {
  // Solo sincronizza lo stato visivo, nessun listener da aggiungere
  document.querySelectorAll('.cart-insurance-checkbox').forEach(cb => {
    cb.disabled = false;
  });
}

async function addInsurance(variantId, productName) {
  const properties = {};
  if (productName) properties['Modello'] = productName;

  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      properties: properties
    })
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.description || 'Add failed');
  }
  return res.json();
}

async function removeInsurance(variantId, productName) {
  const cartRes = await fetch('/cart.js');
  const cart = await cartRes.json();

  const item = cart.items.find(i => {
    if (i.variant_id !== variantId) return false;
    if (!productName) return true;
    const modelProp = i.properties && i.properties['Modello'];
    return modelProp === productName;
  });

  if (!item) return;

  const res = await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: item.key, quantity: 0 })
  });
  if (!res.ok) throw new Error('Remove failed');
  return res.json();
}

async function refreshCartDrawer() {
  return fetch(`${window.Shopify.routes.root}?section_id=cart-drawer`)
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newDrawer = doc.querySelector('.drawer__inner');
      const currentDrawer = document.querySelector('.drawer__inner');
      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
        setTimeout(syncInsuranceCheckboxes, 50);
      }
    });
}